/* eslint-disable @typescript-eslint/ban-ts-comment */
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
export interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  vertical?: boolean;
  horizontal?: boolean;
}
const OldDivider: FC<DividerProps> = ({
  vertical = false,
  horizontal = true,
  ...rest
}) => <DividerInner vertical={vertical} horizontal={horizontal} data-testid="divider" {...rest} />;
export default OldDivider;

// @ts-ignore
const _exp = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.colors.bg.grey600;
const _exp2 = /*#__PURE__*/() => ({
  vertical,
  horizontal
}) => vertical && !horizontal ? '100%' : '1px';
const _exp3 = /*#__PURE__*/() => ({
  vertical,
  horizontal
}) => vertical && !horizontal ? '1px' : '100%';
const DividerInner = withTheme(/*#__PURE__*/styled('div')({
  name: "DividerInner",
  class: "d1jmpmy5",
  propsAsIs: false,
  vars: {
    "d1jmpmy5-0": [_exp()],
    "d1jmpmy5-1": [_exp2()],
    "d1jmpmy5-2": [_exp3()]
  }
}));

require("./OldDivider.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldDivider.tsx");